exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container .app-error .ae-column{margin-bottom:0}", ""]);

